"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("../../misc");

var _IconButton = _interopRequireDefault(require("../IconButton"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CollapseHeader = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Collapse__CollapseHeader"
})(["display:flex;justify-content:space-between;"]);

var ContentWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Collapse__ContentWrapper"
})(["margin-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
});

var DefaultToggleBase = function DefaultToggleBase(props) {
  var _useContext = (0, _react.useContext)(_misc.ThemeContext),
      palette = _useContext.palette;

  return _react["default"].createElement(_IconButton["default"], _extends({
    icon: "chevron-down",
    iconProps: {
      customColor: palette.grey[800]
    }
  }, props));
};

var DefaultToggle = /*#__PURE__*/(0, _styledComponents["default"])(DefaultToggleBase).withConfig({
  displayName: "Collapse__DefaultToggle"
})(["transform:", ";margin-left:auto;transition:", ";background-color:transparent;&:hover{background-color:rgba(0,0,0,0.1);}"], function (_ref2) {
  var checked = _ref2.checked;
  return checked ? 'rotate(180deg)' : 'rotate(0deg)';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  });
});

var Collapse = function Collapse(_ref4) {
  var TitleComponent = _ref4.TitleComponent,
      ToggleComponent = _ref4.ToggleComponent,
      toggleComponentProps = _ref4.toggleComponentProps,
      onToggle = _ref4.onToggle,
      expanded = _ref4.expanded,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["TitleComponent", "ToggleComponent", "toggleComponentProps", "onToggle", "expanded", "children"]);

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1]; // update local state when `expanded` value changes


  (0, _react.useEffect)(function () {
    return setIsExpanded(expanded);
  }, [expanded]);
  var handleExpandClick = (0, _react.useCallback)(function () {
    // TODO: cover this in unit tests
    setIsExpanded(!isExpanded);
    onToggle(!isExpanded);
  }, [onToggle, isExpanded]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(CollapseHeader, null, TitleComponent, ToggleComponent && _react["default"].createElement(ToggleComponent, _extends({
    checked: isExpanded,
    onClick: handleExpandClick
  }, toggleComponentProps))), _react["default"].createElement(_Collapse["default"], {
    "in": isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, _react["default"].createElement(ContentWrapper, null, children)));
};

Collapse.propTypes = {
  TitleComponent: _propTypes["default"].element,
  ToggleComponent: _propTypes["default"].elementType,
  toggleComponentProps: _propTypes["default"].object,
  onToggle: _propTypes["default"].func,
  expanded: _propTypes["default"].bool
};
Collapse.defaultProps = {
  ToggleComponent: DefaultToggle,
  toggleComponentProps: {},
  onToggle: function onToggle() {},
  expanded: false
};
var _default = Collapse;
exports["default"] = _default;